export enum GlobalSettingsContextDispatchActionType {
	setCompactComments,
	setDefaultBreakMinutes,
}
